export enum VehicleQuestionCode {
  /**
   * codes for first step questions
   */
  isAbroad = 'ABROAD',
  isLeasing = 'LEASING',
  isLeftHandDrive = 'LEFT_HAND_DRIVE',
  isGasInstallation = 'GAS_INSTALLATION',
  isValidCarInspection = 'VALID_CAR_INSPECTION',

  /**
   * codes for third step questions
   */
  keysAmount = 'KEYS_AMOUNT',
  originalKeysAmount = 'ORIGINAL_KEYS_AMOUNT',
  leechedKeysAmount = 'LEECHED_KEYS_AMOUNT',
  immobilizer = 'IMMOBILIZER',
  mechanicLockTransmission = 'MECHANIC_LOCK_TRANSMISSION',
  autoalarm = 'AUTOALARM',
  gps = 'GPS',
  usaCanadaRegistration = 'USA_CANADA_REGISTRATION',
  otherSecurities = 'OTHER_SECURITIES',
}
